import { useEffect, useState } from 'react';
import styled from 'styled-components';
import useMediaQuery from '@/hooks/useMediaQuery';
import Logo from '../Header/components/Logo';
import GatewayCopyBlock from './common/GatewayCopyBlock/GatewayCopyBlock';
import StandardHeroBannerBuilder from './common/StandardHeroBanner/StandardHeroBanner';
import StoneCarousel from './common/StoneCarousel/StoneCarousel';
import DoubleImageBanner from './common/DoubleImageBanner/DoubleImageBanner';

const Container = styled.div`
  & div.tw-pointer-events-none {
    pointer-events: all;
  }
  li.stone-carousel__slide > a {
    padding-top: 0 !important;
  }
`;

export default function MaintancePage() {
  const [updateBanner, setUpdateBanner] = useState(false);
  const match = useMediaQuery('(max-width: 640px)');
  useEffect(() => {
    setUpdateBanner(true);
  }, []);

  return (
    <Container>
      <div className="king-header-navgation tw-static tw-mb-[15px]">
        <Logo />
      </div>
      {updateBanner && (
        <StandardHeroBannerBuilder
          mobileTitle="Temporarily Down For Maintenance"
          altImageText="Model wearing diamond engagement ring and assorted jewelry"
          copyColor="black"
          desktopCopyPosition="left"
          description={`<p style="font-size: 18px;"><span >Apologies - we&apos;re adding some sparkle to our site and will be back soon. Call us at </span>${
            match
              ? '<a style="font-size: 18px" href="tel:800.691.0952">800.691.0952</a>.'
              : '<span>800.691.0952.</span>'
          }</p>`}
          title="Temporarily Down For Maintenance"
          isWistia={false}
          autoPlay={false}
          loop={false}
          controls={false}
          margin
          background={{
            desktop: '/bee2-ui/img/maintenance/hero_desktop.jpg',
            mobile: '/bee2-ui/img/maintenance/hero_mobile.jpg',
          }}
          actions={[]}
          desktopVideoUri={undefined}
          mobileVideoUri={undefined}
          anchorLinkID={undefined}
          sectionLink={undefined}
          fileVideoSrc={undefined}
          fileMobileVideoSrc={undefined}
          hasSound={false}
        />
      )}
      {updateBanner && (
        <DoubleImageBanner
          alignmentOptions="center"
          anchorLinkID=""
          margin={false}
          outlineMargin={false}
          textPosition="center"
        />
      )}
      <GatewayCopyBlock
        background="Dark Green"
        description="<p> Visit the Brilliant Earth blog and become an expert on top trends.</p>"
        imgSrc="/bee2-ui/img/maintenance/gateway.jpg"
        optionalLargeHeader="Can't wait to start shopping?"
        mediaLeft
        isVideo={false}
        autoPlay
        loop
        controls
        actions={[
          {
            dropdown: false,
            type: 'secondary',
            color: 'white',
            label: 'Visit Our Blog',
            href: '/guides/',
          },
        ]}
      />
      <div className="tw-mt-8 md:tw-mt-14">
        <StoneCarousel
          itemSize="small"
          items={[
            {
              img: '/bee2-ui/img/maintenance/yt.svg',
              title: 'YouTube',
              url: 'https://www.youtube.com/watch?v=ERhI4ULhFlc',
              alt: 'YouTube icon',
            },
            {
              img: '/bee2-ui/img/maintenance/ig.svg',
              title: 'Instagram',
              url: 'https://www.instagram.com/brilliantearth/',
              alt: 'Instagram icon',
            },
            {
              img: '/bee2-ui/img/maintenance/fb.svg',
              title: 'Facebook',
              url: 'https://www.facebook.com/brilliantearth',
              alt: 'Facebook icon',
            },
            {
              img: '/bee2-ui/img/maintenance/pinterest.svg',
              title: 'Pintrest',
              url: 'https://www.pinterest.com/brilliantearth/',
              alt: 'Pintrest icon',
            },
            {
              img: '/bee2-ui/img/maintenance/x.svg',
              title: 'X',
              url: 'https://twitter.com/BrilliantEarth',
              alt: 'X icon',
            },
            {
              img: '/bee2-ui/img/maintenance/linkedin.svg',
              title: 'LinkedIn',
              url: 'https://www.linkedin.com/company/brilliant-earth/',
              alt: 'LinkedIn icon',
            },
          ]}
          title={{
            content: '',
          }}
        />
      </div>
    </Container>
  );
}
